module.exports = __webpack_public_path__ + "img/96ne.f1aa7e3d.svg";